import { Component, Input, HostBinding, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'labeled-separator',
  templateUrl: './labeled.separator.template.html',
  styleUrls: ['./labeled.separator.styles.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class LabeledSeparatorComponent {
  @Input() label: string;
  @Input() type: string;
  @HostBinding('class') get hostClasses(): string {
    return `${this.type}`;
  }
}
